//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { datesToHuman } from '@/utils/dates.js'

export default {
  name: 'MainQuotes',
  data() {
    return {
      expandedQuoteKeys: [],
    }
  },
  computed: {
    quotes() {
      return this.normalizeQuotes(this.$store.getters['objects/getMainQuotes']).slice(0, 4)
    },
  },
  methods: {
    normalizeQuotes(payload) {
      const source = Array.isArray(payload?.items) ? payload.items : payload
      const rows = Array.isArray(source) ? source : []

      return rows
        .map((item) => {
          const quote = Array.isArray(item?.items) ? item.items[0] : item
          const object = item?.vistat_object_annotated || item?.object || quote?.vistat_object_annotated || quote?.object

          return {
            ...quote,
            object,
            objectLabel: item?.label || item?.object_label || quote?.object_label,
            subjects: Array.isArray(quote?.subjects) ? quote.subjects : [],
            dateHumanReadable: quote?.dateHumanReadable || this.formatQuoteDate(quote?.date),
          }
        })
        .filter((quote) => quote?.text)
    },
    formatQuoteDate(date) {
      if (!date?.vfrom) return ''
      const humanDate = datesToHuman({ value: date.vfrom }, { value: date.vto })
      return Array.isArray(humanDate) ? humanDate.join(' ') : humanDate
    },
    quoteKey(quote) {
      return quote.id || quote.uuid || `${quote.text}-${this.quoteSource(quote)}`
    },
    quoteSource(quote) {
      return quote.object?.label || quote.objectLabel || ''
    },
    quoteLink(quote) {
      const object = quote.object
      const slug = object?.slug || object?.id
      return slug ? { name: 'objects-slug', params: { slug } } : null
    },
    subjectKey(subject) {
      return typeof subject === 'object' ? subject.id || subject.label : subject
    },
    subjectLabel(subject) {
      return typeof subject === 'object' ? subject.label || subject.id : subject
    },
    isQuoteOpened(quote) {
      return this.expandedQuoteKeys.includes(this.quoteKey(quote))
    },
    toggleQuote(quote) {
      const key = this.quoteKey(quote)
      if (this.expandedQuoteKeys.includes(key)) {
        this.expandedQuoteKeys = this.expandedQuoteKeys.filter((item) => item !== key)
      } else {
        this.expandedQuoteKeys = [...this.expandedQuoteKeys, key]
      }
    },
  },
}
